import { createApp } from 'vue'
// import '../stylesheets/application.scss'
import '../stylesheets/chat.css'

// import "@hotwired/turbo-rails"

// Import Chart.js for Chartkick
import { Chart, registerables } from 'chart.js'
Chart.register(...registerables)
window.Chart = Chart
console.log('Vite ⚡️ Rails + Vue 3')

// Auto-mount Vue components
// Components should be placed in app/frontend/components
// Use data-vue-component="ComponentName" to auto-mount

const componentModules = import.meta.glob('../components/**/*.vue', { eager: true })

// Handle data-method links (for DELETE, POST, PATCH requests)
document.addEventListener('click', (e) => {
  const link = e.target.closest('a[data-method]')
  if (!link) return

  const method = link.dataset.method.toLowerCase()
  if (method === 'get') return

  e.preventDefault()

  // Check for confirmation
  if (link.dataset.confirm) {
    if (!confirm(link.dataset.confirm)) return
  }

  // Create and submit a form
  const form = document.createElement('form')
  form.method = 'POST'
  form.action = link.href

  // Add CSRF token
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
  if (csrfToken) {
    const csrfInput = document.createElement('input')
    csrfInput.type = 'hidden'
    csrfInput.name = 'authenticity_token'
    csrfInput.value = csrfToken
    form.appendChild(csrfInput)
  }

  // Add method override for non-POST methods
  if (method !== 'post') {
    const methodInput = document.createElement('input')
    methodInput.type = 'hidden'
    methodInput.name = '_method'
    methodInput.value = method
    form.appendChild(methodInput)
  }

  document.body.appendChild(form)
  form.submit()
})

// Auto-mount components on page load
document.addEventListener('DOMContentLoaded', () => {
  const mountPoints = document.querySelectorAll('[data-vue-component]')

  mountPoints.forEach((el) => {
    const componentName = el.dataset.vueComponent

    // Find the component module
    const componentPath = Object.keys(componentModules).find(path =>
      path.includes(`${componentName}.vue`)
    )

    if (componentPath) {
      const component = componentModules[componentPath].default
      const props = el.dataset.vueProps ? JSON.parse(el.dataset.vueProps) : {}

      const app = createApp(component, props)
      app.mount(el)
    } else {
      console.warn(`Vue component not found: ${componentName}`)
    }
  })
})
